<template>
  <div class="inventoryList">
    <el-table
      :data="tableData"
      style="width: 100%; margin-bottom: 20px"
      v-loading="tableLoading"
    >
      <el-table-column
        min-width="140"
        align="center"
        :label="$t('devices.aps.storeName')"
        prop="storeName"
      >
        <el-table-column min-width="140" align="center" prop="storeName">
        </el-table-column>
      </el-table-column>
      <el-table-column
        min-width="200"
        align="center"
        :label="$t('devices.inventory.Esl Code')"
        prop="tagIdentity"
      >
        <el-table-column min-width="200" align="center" prop="tagIdentity">
          <template slot="header" slot-scope="scope">
            <el-input
              v-model="pageParams.tagIdentity"
              @input="getList"
              size="small"
              clearable
            />
          </template>
        </el-table-column>
      </el-table-column>

      <el-table-column
        min-width="160"
        align="center"
        :label="$t('devices.inventory.Esl Type')"
        prop="tagTypeName"
      >
        <el-table-column min-width="160" align="center" prop="tagTypeName">
          <template slot="header" slot-scope="scope">
            <el-select
              v-model="pageParams.tagTypeId"
              clearable
              size="small"
              @change="getList"
            >
              <el-option
                v-for="item in tagTypeLists"
                :key="item.tagTypeCodeId"
                :label="item.typeName"
                :value="item.tagTypeCodeId"
              >
              </el-option>
            </el-select>
          </template>
        </el-table-column>
      </el-table-column>

      <el-table-column
        min-width="180"
        align="center"
        :label="$t('devices.inventory.operator')"
        prop="createUser"
      >
        <el-table-column min-width="180" align="center" prop="createUser">
          <template slot="header" slot-scope="scope"> </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        min-width="200"
        align="center"
        :label="$t('devices.inventory.state')"
        prop="stateName"
      >
        <el-table-column min-width="200" align="center" prop="stateName">
          <template slot="header" slot-scope="scope">
            <el-select
              v-model="pageParams.state"
              clearable
              size="small"
              @change="getList"
            >
              <el-option
                v-for="item in stateLists"
                :key="item.codeId"
                :label="item.codeName"
                :value="item.codeId"
              >
              </el-option>
            </el-select>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        min-width="180"
        align="center"
        :label="$t('devices.inventory.startTime')"
        prop="createTime"
      >
        <el-table-column min-width="180" align="center" prop="createTime">
          <template slot="header" slot-scope="scope"> </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        min-width="180"
        align="center"
        :label="$t('devices.inventory.endTime')"
        prop="updateTime"
      >
        <el-table-column min-width="180" align="center" prop="updateTime">
          <template slot="header" slot-scope="scope"> </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        align="center"
        min-width="120"
        :label="$t('devices.aps.remark')"
        prop="note"
      >
        <el-table-column align="center" min-width="120" prop="note">
          <template slot="header" slot-scope="scope"> </template>
        </el-table-column>
      </el-table-column>
    </el-table>
    <pagination :tableInfo="pageParams" @changePage="changePage" />
  </div>
</template>
<script>
import pagination from "@/components/pagination";
import { getCodeList } from "@/libs/api/aps";
import { inventoryDetailList, getAllTagType } from "@/libs/api/inventory";

export default {
  components: {
    pagination,
  },
  props: {
    clickRow: {
      type: Object,
      require: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      tableLoading: false,
      tableData: [],
      pageParams: {
        tagIdentity: "", // 价签条码
        tagTypeId: "", // 价签类型
        state: "", // 价签状态(正常:3701 闲置:3702 返厂: 3703 报修: 3704 报废:3705 异常: 3706 补登:3707)	是	Integer	query
        taskState: "", // 任务状态，0：发送失败；1：已发送；2：已执行；3：执行结束	是	Integer	query
        tagIdentity: "", // 价签条码	是	String	query
        current: 1, //	当前页
        size: 10,
        total: 0,
      },
      isVisibleEndDialog2: false,
      rowData: {},
      loading: false,
      tagTypeLists: [],
      stateLists: [],
    };
  },
  watch: {
    clickRow: {
      handler(val, oldVal) {
        console.log(val);
        this.getList();
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    console.log(this.clickRow);
    this.getStateList();
    this.getList();
    this.getTagTypeList();
  },
  methods: {
    changePage() {
      this.getList();
    },
    getList() {
      console.log(123);
      console.log(this.clickRow);
      console.log(this.clickRow.id, "aaaaaa");
      const params = {
        id: this.clickRow.id,
        ...this.pageParams,
      };
      inventoryDetailList(params).then((res) => {
        console.log(res);
        this.tableData = res.data.data.records;
        this.pageParams.total = res.data.data.total;
      });
    },

    handelEnd(row) {
      this.rowData = row;
      this.isVisibleEndDialog2 = true;
    },

    getTagTypeList() {
      const userData = JSON.parse(localStorage.getItem("userData"));
      const params = {
        merchantId: userData.merchantId,
      };
      getAllTagType(params).then((res) => {
        console.log(res);
        this.tagTypeLists = res.data.data;
      });
    },

    getStateList() {
      let params = {
        cateId: 37,
      };
      getCodeList(params).then((res) => {
        console.log(res);
        this.stateLists = res.data.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-info {
  font-size: 19px;
}
.icon-info:before {
  content: "";
}
.dialog-footer ::v-deep {
  text-align: center;
  .el-button {
    width: 110px;
    height: 40px;
  }

  .btn {
    // border-radius: 10px;
  }
  .el-button.cancel-btn {
    background: #d4d4d4 !important;
    box-shadow: 0px 1px 15px 0px rgba(99, 99, 99, 0.23);
    color: #626262;
  }
  .el-button.save-btn {
    background: #35b871 !important;
    box-shadow: 0px 1px 15px 0px rgba(53, 184, 113, 0.55);
    color: #ffffff;
  }
}
.dialog-footer ::v-deep {
  text-align: center;
  .el-button {
    width: 110px;
    height: 40px;
    border: none;
  }
  .el-button.cancel-btn {
    background: #d4d4d4 !important;
    box-shadow: 0px 1px 15px 0px rgba(99, 99, 99, 0.23);
    color: #626262;
  }
  .el-button.save-btn {
    background: #35b871 !important;
    box-shadow: 0px 1px 15px 0px rgba(53, 184, 113, 0.55);
    color: #ffffff;
  }
}
</style>
